import React from 'react';
import MuiButton, { ButtonProps } from '@material-ui/core/Button';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { TinkFontSizes } from '../../providers/ThemeProvider/theme';
import { MarginProps, styledMargin } from '../Margins/margins';

export type TextButtonProps = {
  bold?: boolean;
  fontSize?: TinkFontSizes;
};

/**
 * We need to add these to avoid type errors. They will be sent down to the root component.
 */
export type ExtendedButtonProps = {
  rel?: string;
  target?: string;
  component?: any;
  to?: string;
} & ButtonProps &
  MarginProps;

export const StyledMuiButton = styled(MuiButton as React.FC)<ButtonProps>`
  && {
    text-transform: none;
    border-radius: ${(props) => (props.fullWidth ? '0' : '')};
    ${styledMargin}
  }
`;

export const Button: React.FC<ExtendedButtonProps> = (props) => {
  const allParams = props.target === '_blank' ? { ...props, rel: 'noopener noreferrer' } : props;

  return <StyledMuiButton disableRipple {...allParams} />;
};

export const ButtonBase: React.FC<ExtendedButtonProps> = (props) => (
  <MuiButton disableRipple {...props} />
);

export const LinkButton: React.FC<ExtendedButtonProps> = ({
  variant,
  size,
  color,
  children,
  ...props
}) => (
  <StyledMuiButton
    disableRipple
    variant={variant || 'contained'}
    size={size || 'large'}
    color={color || 'primary'}
    component={props.href ? 'a' : Link}
    {...props}
  >
    {children}
  </StyledMuiButton>
);

export const TextButton = styled(({ bold, ...props }) => (
  <ButtonBase {...props} />
))<TextButtonProps>`
  && {
    min-width: auto;
    min-height: auto;
    padding: 0;
    font-size: ${(props) =>
      props.fontSize ? props.theme.sizes[props.fontSize] : props.theme.sizes.small};
    font-weight: ${(props) =>
      props.bold ? props.theme.font.weights.semiBold : props.theme.font.weights.regular};
  }

  ${(props) =>
    props.color === 'inherit' &&
    `
    &&:hover {
      color: inherit;
      opacity: 0.6
    }
  `}
`;

export const DottedButton = styled(TextButton).attrs({
  disableRipple: true,
})`
  && {
    border: 1px dotted ${(props) => props.theme.palette.primary[400]};
    border-radius: ${(props) => props.theme.roundedCorners.xsmall};
    padding-top: ${(props) => props.theme.sizes.normal};
    padding-bottom: ${(props) => props.theme.sizes.normal};
  }
`;
